// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // // //Productions
  baseUrl: "https://api-rdbms.mobiloitte.io/",
  apiUrl: "https://api-rdbms.mobiloitte.io/api",
  masterApiUrl: "https://api-rdbms.mobiloitte.io/api",
  apiSecurityKey: "RDBMS-API-KEY-2026-SECURE-TOKEN-v4_b7F!9kL2@xQ#pR8$wZ6^nM3cT5YvH1JdE0aSgUoXl",
  googleMapApiKey: "AIzaSyCO-TVJqbWr654TGF6Feq4rnBOUq48q_hM"

  //local
  // baseUrl: "https://x5b58rrn-5124.inc1.devtunnels.ms/",
  // apiUrl: "https://x5b58rrn-5124.inc1.devtunnels.ms/api",
  // masterApiUrl: "https://x5b58rrn-5124.inc1.devtunnels.ms/api",
  // apiSecurityKey: "RDBMS-API-KEY-2026-SECURE-TOKEN-v4_b7F!9kL2@xQ#pR8$wZ6^nM3cT5YvH1JdE0aSgUoXl",
  // googleMapApiKey: "AIzaSyCO-TVJqbWr654TGF6Feq4rnBOUq48q_hM",



  // baseUrl: "http://localhost:5124/",
  // apiUrl: "http://localhost:5124/api",
  // masterApiUrl: "http://localhost:5124/api",
  // apiSecurityKey: "RDBMS-API-KEY-2026-SECURE-TOKEN-v4_b7F!9kL2@xQ#pR8$wZ6^nM3cT5YvH1JdE0aSgUoXl",
  // googleMapApiKey: "AIzaSyCO-TVJqbWr654TGF6Feq4rnBOUq48q_hM",
};
